import { motion } from "framer-motion";

const QUOTES = [
  {
    name: "Diego Aguilar",
    title: "Art Director · Illustrator · Muralist · Graphic Designer",
    rel: "Reported directly to John",
    headline: "Creative leadership that actually elevates a team.",
    body: "I had the chance to work under John, and he consistently went above and beyond in every aspect of his role. His ability to bring fresh, innovative marketing ideas to the table not only elevated our work — it elevated the people doing it.",
  },
  {
    name: "Alex Russell",
    title: "SDR Lead, JumpSeat",
    rel: "Worked with John on the same team",
    headline: "Client trust plus strategic excellence.",
    body: "First, his ability to build genuine client relationships is something I haven&apos;t often seen matched. John has a natural ease with people that goes beyond being likable — clients trusted him, and that trust turned into retention and real strategic excellence.",
  },
  {
    name: "Jackie Fisher",
    title: "Change Agent · Profit Driver · Six Sigma Black Belt",
    rel: "Managed John directly",
    headline: "Adaptable. Solution-focused. Team-first.",
    body: "John is truly an asset — he has grown exponentially in the past year; his willingness to learn, adapt, and embrace change has been remarkable. As he transitioned from a social media focus to a broader strategic role, he never missed a beat.",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="bg-[#111111] text-[#F2EFE9] px-4 md:px-8 lg:px-12 py-20 md:py-28">
      <div className="mb-12 md:mb-16 max-w-6xl">
        <div className="font-mono-s text-[11px] tracking-[0.3em] uppercase text-[#F2EFE9]/60 mb-3">
          § 07 — Recommendations
        </div>
        <h2 className="font-anton uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.92]">
          In the words of the
          <span className="font-cormorant italic text-[#D83127] font-semibold"> people </span>
          I&apos;ve built with.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {QUOTES.map((q, i) => (
          <motion.blockquote
            key={q.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="border border-[#333333] p-6 md:p-8 bg-[#1a1a1a] relative"
            data-testid={`testimonial-${i}`}
          >
            <div className="font-cormorant italic text-5xl md:text-6xl leading-none text-[#D83127] mb-2">“</div>
            <div className="font-anton uppercase text-2xl md:text-3xl leading-tight mb-4">
              {q.headline}
            </div>
            <p
              className="font-cormorant italic text-lg md:text-xl leading-relaxed text-[#F2EFE9]/90"
              dangerouslySetInnerHTML={{ __html: q.body }}
            />
            <div className="mt-6 pt-4 border-t border-[#333333]">
              <div className="font-anton uppercase text-xl">{q.name}</div>
              <div className="font-mono-s text-[10px] tracking-[0.2em] uppercase text-[#F2EFE9]/60 mt-1">
                {q.title}
              </div>
              <div className="font-mono-s text-[10px] tracking-[0.2em] uppercase text-[#D83127] mt-1">
                ▸ {q.rel}
              </div>
            </div>
          </motion.blockquote>
        ))}
      </div>

      <div className="mt-10">
        <a
          href="https://jpkuster.com/testimonials"
          target="_blank"
          rel="noopener noreferrer"
          className="link-underline font-mono-s text-xs uppercase tracking-[0.25em]"
          data-testid="testimonials-view-all"
        >
          Read all recommendations →
        </a>
      </div>
    </section>
  );
}
